import omit from 'lodash-es/omit';
import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import isObject from 'lodash-es/isObject';
import pick from 'lodash-es/pick';
import getDisabledStyle from '../css/disabledStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import { getDefaultControlStyle, getDefaultControl } from './textInput.defaults';
import Control from './control';

export default class TextInput extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this, 'text', () =>
      this._checkDataOption('text', this._controlOptions.placeholder || ''), {
      formatter: 'placeholder.placeholderFormatter'
    });

    // Override value API to add valueFormatter support
    this.addApi(
      this,
      'value',
      () =>
        this._checkDataOption(
          'value',
          this._controlOptions.value !== undefined
            ? isObject(this._controlOptions.value) && !Array.isArray(this._controlOptions.value)
              ? this._controlOptions.value.defaultValue
              : this._controlOptions.value
            : undefined
        ),
      {
        formatter: 'valueFormatter',
        persistent: !this.isLayoutMode&&!this.isDesignMode,
        twoWay: true,
        onChange:(value,oldValue)=> this.raiseEvent('change',{value,oldValue})
      }
    );
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    options.valueType = options.valueType || 'text';
    if (!control.el) {
      control.el = getDefaultControl(instance, options);
      if (!control.isLayoutMode) {
        var bodyEl = control.el.getElementsByClassName('body')[0];

        bodyEl.addEventListener('change', function(ev) {
          control.value = this.value;
          // console.log('textInput change', this.value);
          // console.log(control.value);
          // updateDataSourceParameter(control, options, instance);

          if (options.trigger) {
            if (!isFunction(options.trigger)) {
              console.error("textInput's change trigger should be a function", options.trigger);
            } else {
              options.trigger.apply(this, [options, instance, control, path, ev]);
            }
          }

          if (options.event) {
            if (!isString(options.event)) {
              console.error("textInput's change event should be a string", options.event);
            } else {
              instance.fire(
                options.event,
                pick(options, ['name', 'options', 'type', 'gridElement']),
                control,
                path,
                ev
              );
            }
          }

          control.doResetReload();
        });
        bodyEl.addEventListener('mouseover', function() {
          control.isHover = true;
          control.render();
        });
        bodyEl.addEventListener('mouseout', function() {
          control.isHover = false;
          control.render();
        });
        bodyEl.addEventListener('focus', function() {
          control.isFocused = true;
          control.render();
        });
        bodyEl.addEventListener('blur', function() {
          control.isFocused = false;
          control.render();
        });
        bodyEl.addEventListener('input', function() {
          control.value = this.value;
          // console.log(control.value);
        });
      }
    }

    if (!options.value) {
      options.value = {};
    }

    if (options.value.defaultValue === undefined) {
      options.value.defaultValue = '';
    }

    var stylePatch = {};
    var bodyStylePatch = {};
    bodyEl = control.el.getElementsByClassName('body')[0];
    var frameProps = [
      'top',
      'left',
      'right',
      'bottom',
      'margin',
      'position',
      'display',
      'width',
      'height',
    ];
    var defaultStyle = getDefaultControlStyle(control, options);

    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, frameProps));
      merge(bodyStylePatch, omit(options.style.normal, frameProps));
    }

    merge(stylePatch, control.frameStyle);

    if (control.isFocused) {
      merge(stylePatch, defaultStyle.focused);
      merge(bodyStylePatch, defaultStyle.body.focused);
      if (options.style && options.style.focused) {
        merge(stylePatch, pick(options.style.focused, frameProps));
        merge(bodyStylePatch, omit(options.style.focused, frameProps));
      }
    }

    if (control.isHover) {
      merge(stylePatch, defaultStyle.hover);
      merge(bodyStylePatch, defaultStyle.body.hover);
      if (options.style && options.style.hover) {
        merge(stylePatch, pick(options.style.hover, frameProps));
        merge(bodyStylePatch, omit(options.style.hover, frameProps));
      }
    }

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef([stylePatch, bodyStylePatch], scheme);
    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;
    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    if (control.isLayoutMode) {
      bodyEl.style.pointerEvents = 'none';
    }

    control.currentBodyStyle = bodyStylePatch;

    //if (control.designMode !== 'layout') {
    bodyEl.value = control.value;
    if (control.readOnly || control.disabled) {
      bodyEl.setAttribute('readonly', 'readonly');
    } else {
      bodyEl.removeAttribute('readonly');
    }
    // } else {
    //   bodyEl.innerText = control.value || options.valueType || '';
    // }

    bodyEl.placeholder = control.text;

    return control.el;
  }
}
